import { Empty as AntdEmpty } from 'antd';
import { EmptyProps as AntdEmptyProps } from 'antd/lib/empty';

export type EmptyProps = AntdEmptyProps;

export const Empty = AntdEmpty;
export default Empty;
